import ResourceManager from "@/pages/admin/components/ResourceManager";
import { galleryCategoryLabels, galleryCategoryOptions } from "@/lib/galleryMeta";
import { formatFecha } from "@/lib/format";
import type { ColumnConfig, FieldConfig } from "@/lib/adminFields";
import type { GalleryCategory } from "@/types";

const fields: FieldConfig[] = [
  { name: "titulo", label: "Título del trabajo", type: "text", required: true },
  { name: "categoria", label: "Categoría", type: "select", required: true, options: galleryCategoryOptions },
  { name: "fecha", label: "Fecha", type: "date" },
  { name: "orden", label: "Orden", type: "number", help: "Número menor aparece primero" },
  { name: "activo", label: "Visible en el sitio", type: "switch" },
  { name: "descripcion", label: "Descripción", type: "textarea", full: true },
  { name: "imagen_url", label: "Fotografía", type: "image", full: true, folder: "galeria" },
];

const columns: ColumnConfig[] = [
  { name: "imagen_url", label: "Foto", type: "image" },
  { name: "titulo", label: "Trabajo" },
  { name: "categoria", label: "Categoría", type: "muted" },
  { name: "fecha", label: "Fecha", type: "muted" },
  { name: "activo", label: "Visibilidad", type: "switch" },
];

export default function AdminGaleria() {
  return (
    <ResourceManager
      table="galeria"
      title="Gestión de galería"
      description="Administra los trabajos realizados: fotografía, categoría, fecha y visibilidad en el portafolio."
      itemSingular="trabajo"
      itemPlural="trabajos"
      emptyIcon="ri-gallery-line"
      titleField="titulo"
      subtitleField="categoria"
      imageField="imagen_url"
      searchPlaceholder="Buscar por título…"
      fields={fields}
      columns={columns}
      renderCell={(row, column) => {
        if (column.name === "categoria") {
          return (
            <span className="text-sm text-foreground-600">
              {galleryCategoryLabels[row.categoria as GalleryCategory] ?? String(row.categoria ?? "—")}
            </span>
          );
        }
        if (column.name === "fecha") {
          return <span className="text-sm text-foreground-500">{row.fecha ? formatFecha(String(row.fecha)) : "—"}</span>;
        }
        return undefined;
      }}
    />
  );
}